<template>
  <div>
    <VAV></VAV>
  </div>
</template>

<script>
import VAV from '../components/ViaplyVerify.vue';

export default {
  components: {
    VAV,
  },
};
</script>
